<template>
  <ul class="pagination justify-content-center mt-0">
    <li
      class="page-item"
      :class="{ 'disabled': currentPage === 0 || isSearching }"
      v-if="total > 0">
      <a
        class="page-link"
        :href="0"
        @click.prevent="goToPage(0)">
        <font-awesome-icon :icon="['fas', 'angle-double-left']" /></a>
    </li>
    <li
      class="page-item"
      :class="{ 'disabled': (currentPage - 1) < 0 || isSearching }"
      v-if="total > 0">
      <a
        class="page-link"
        :href="currentPage"
        @click.prevent="goToPage(currentPage - 1)">
        <font-awesome-icon :icon="['fas', 'angle-left']" /></a>
    </li>
    <li
      class="page-item"
      v-for="(page, index) in pages"
      :key="index"
      :class="{ 'active disabled': currentPage === index || isSearching }">
      <a
        class="page-link"
        :href="page"
        @click.prevent="goToPage(index)">
        {{ page }}
      </a>
    </li>
    <li
      class="page-item"
      :class="{ 'disabled': (currentPage + 1) > perPage || isSearching }"
      v-if="total > 0">
      <a
        class="page-link"
        :href="currentPage + 2"
        @click.prevent="goToPage(currentPage + 1)">
        <font-awesome-icon :icon="['fas', 'angle-right']" /></a>
    </li>
    <li
      class="page-item"
      :class="{ 'disabled': currentPage === pages - 1 || isSearching }"
      v-if="total > 0">
      <a
        class="page-link"
        :href="pages"
        @click.prevent="goToPage(pages - 1)">
        <font-awesome-icon :icon="['fas', 'angle-double-right']" /></a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ImagePickerPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 21
    },
    currentPage: {
      type: Number,
      default: 0
    },
    isSearching: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    pages () {
      return Math.ceil(this.total / this.perPage)
    },
    _test () {
      return {
        total: this.total,
        perPage: this.perPage,
        pages: this.pages,
        currentPage: this.currentPage,
        isSearching: this.isSearching
      }
    }
  },
  methods: {
    goToPage (page) {
      this.currentPage = this.currentPage + this.perPage
      this.$emit('onPage', page)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
